<div class="container mt-lg-5 mt-2">
  <form class="col-12 col-lg-10 offset-lg-1 px-lg-5 d-flex flex-column" [formGroup]="form" (ngSubmit)="onSubmit()">
    <h1 class="text-center">Employer-sponsored membership, care when you need it</h1>
    <p class="mb-3">You have access to an employer-sponsored One Medical membership that includes:</p>
    <ul>
      <li class="mb-3">
        <strong>Scheduled Virtual Primary Care</strong><br />
        As early as same- or next-day visits for preventive care, chronic conditions, and everyday health needs.
      </li>
      <li class="mb-3">
        <strong>24/7 On-Demand Care</strong><br />
        Unlimited video visits, messaging, and prescription renewals for urgent health concerns at no extra cost.
      </li>
      <li class="mb-3">
        <strong>Care Access While Traveling</strong><br />
        When you're near a One Medical location, book in-person appointments at any of our clinics nationwide.
      </li>
    </ul>
    <p>All membership features conveniently available through the One Medical app.</p>
    <div class="col-12 col-md-8 offset-md-2">
      <div class="mt-3">
        <om-submit-button class="col-12" label="Next" [submitting]="submitting"></om-submit-button>
      </div>
    </div>
  </form>
</div>
